import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubAboutHeCompareContentSectionHeaderHelium3Cls: string;
			heHubAboutHeCompareContentSectionHeaderVsCls: string;
			heHubAboutHeCompareContentSectionHeaderHelium4Cls: string;
			heHubAboutHeCompareContentSectionTextCls: string;
			heHubAboutHeCompareHeaderCircleCls: string;
			heHubAboutHeCompareLegalTextCls: string;
		}
	},

	slug: string
}

class Compare extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub About He Compare Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionHeaderHelium3Cls || '', 'he_hub_about_he_compare', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionHeaderVsCls || '', 'he_hub_about_he_compare', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionHeaderHelium4Cls || '', 'he_hub_about_he_compare', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionTextCls + '1', 'he_hub_about_he_compare', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionTextCls + '2', 'he_hub_about_he_compare', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionTextCls + '3', 'he_hub_about_he_compare', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionTextCls + '4', 'he_hub_about_he_compare', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionTextCls + '5', 'he_hub_about_he_compare', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareContentSectionTextCls + '6', 'he_hub_about_he_compare', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareHeaderCircleCls + '1', 'he_hub_about_he_compare', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareHeaderCircleCls + '2', 'he_hub_about_he_compare', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareHeaderCircleCls + '3', 'he_hub_about_he_compare', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeCompareLegalTextCls || '', 'he_hub_about_he_compare', { animCls: 'animate__fadeInDown50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Compare;